import React from "react";
import PropTypes from "prop-types";
import classes from "../../FitnessPreview.module.scss";
import Tag from "./CustomTag";

const TAG_COLORS = ["#3ECAE3", "#237799", "#FE8BFF", "#8323F1"];

const ProgramTags = ({ tags = [] }) => {

    return <div className={classes.tagsContainer}>
        {tags.map((tag, i) => (
            <Tag key={i} backgroundColor={TAG_COLORS[i % TAG_COLORS.length]}>
                {tag}
            </Tag>
        ))}
    </div>
}

export default ProgramTags;

ProgramTags.propTypes = {
    tags: PropTypes.arrayOf(PropTypes.string),
};